import { Link } from "react-router-dom";
import {
  IconMail,
  IconPhone,
  IconWhatsApp,
  IconInstagram,
  IconFacebook,
} from "./Icons";
import { LinkWithoutBg, PrimaryLink } from "./Links";

export default function Footer({showWorkWithUs = true}) {
  return (
    <footer className="bg-gray-100 text-gray-700 py-10 border-t">
      <div className="max-w-6xl mx-auto px-8 flex md:flex-row flex-col gap-12 md:gap-8 justify-between">
        <Link to="/" className="flex flex-col items-start gap-4 h-min">
            <img src="/logo.svg" alt="Logo Soluciones Hogar" className="h-10 w-auto" />
        </Link>
        
        <div className="flex flex-col gap-2">
          <h3 className="text-base font-semibold mb-2">Contacto</h3>
          <LinkWithoutBg href="tel:52542124" className="flex gap-2 font-normal"  >
            <IconPhone className="w-5 h-5 min-w-min" />
            <span>5254-2124</span>
          </LinkWithoutBg>
          <LinkWithoutBg target="__blank" href="https://wa.me/541145784578" className="flex gap-2 font-normal" >
            <IconWhatsApp className="w-5 h-5 min-w-min" />
            <span>11-5098-1730</span>
          </LinkWithoutBg>
          <LinkWithoutBg href="mailto:info@solucioneshogar.com" className="flex gap-2 font-normal"  >
            <IconMail className="w-5 h-5 min-w-min" />
            <span>info@solucioneshogar.com</span>
          </LinkWithoutBg>
          <div className="flex items-center gap-3 mt-3">
            <LinkWithoutBg target="__blank" href="https://www.instagram.com/solucioneshogar/">
              <IconInstagram className="w-6 h-6" />
            </LinkWithoutBg>
            <LinkWithoutBg target="__blank" href="https://www.facebook.com/solucioneshogar">
              <IconFacebook className="w-6 h-6" />
            </LinkWithoutBg>
          </div>
        </div>

        {showWorkWithUs&&<div className="flex flex-col">
          <h3 className="text-base font-semibold mb-2 flex items-center gap-4">
            ¿Sos técnico independiente?
          </h3>
          <PrimaryLink
            href="https://wa.me/5491150981730?text=Hola, me gustaría postularme como técnico independiente"
            className=""
          >
            Postulate como técnico
          </PrimaryLink>
        </div>}
      </div>
    </footer>
  );
}
